module.exports = __webpack_public_path__ + "img/logo.475bb271.jpg";